import React, {Fragment,Component,useState,useEffect} from 'react';
import {connect} from 'react-redux';
import Iframe from "react-iframe"
import { Redirect,Link } from 'react-router-dom';
import { Table,Placeholder } from 'semantic-ui-react';
import {
  Menu,
  Segment,
  Container,
  Divider,
  Message,
  Icon,
  Header,
  Dimmer,
  Responsive,
  Modal,
  Button,
  Image,
  Loader,
  Tab,
  Label
} from 'semantic-ui-react';
import {Base64} from 'js-base64';
import Clipboard from 'react-clipboard.js';

function Guide(props){

  const {t}       = props;
  const mobile    = /Android|iPhone|iPod/.test(navigator.userAgent);
  const title     = props.data.title;
  const port      = props.data.port;
  const password  = props.data.password;
  const code      = props.data.code;
  const hashed    = props.data.hashed;
  const user_id   = props.data.user_id;
  const user_vip  = props.data.user_vip;

  const winDownload         = "https://glados.one/tools/mihomo-party-windows-1.5.12-x64-setup.exe";
  const armDownload         = "https://glados.one/tools/mihomo-party-macos-1.5.12-arm64.pkg";
  const x86Download         = "https://glados.one/tools/mihomo-party-macos-1.5.12-x64.pkg";
  const apkDownload         = "https://glados.one/tools/cmfa-2.11.4-meta-universal-release.apk"

  var subscribe_endpoint = "update.glados-config.com";
  var alt_subscribe_endpoint = "www.glados-config.com";

  const suburl           = `https://${subscribe_endpoint}/mihomo/${user_id}/${code}/${port}/glados.yaml`
  const altsub           = `https://${alt_subscribe_endpoint}/mihomo/${user_id}/${code}/${port}/glados.yaml`

  var panes = [{
      desktop:true,
      mobile:true,
      menuItem:<Menu.Item key='pro2'>
        <svg id="windows" style={{"color":"#333","width":"26px","marginRight":"8px", "verticalAlign": "middle"}}   viewBox="0 0 36 24">
          <path d="M6.5 3.27934L15.9055 1.99281V11.051H6.5V3.27934ZM17.0384 1.81427L29.5 0V10.9749H17.0384V1.81427ZM6.5 12.0094H15.9055V21.0938L6.5 19.7811V12.0094ZM17.0384 12.1301H29.5V23L17.0384 21.2409" fill="currentColor"></path>
        </svg>
        Windows
      </Menu.Item>,
      render: () => {

        return (<Tab.Pane style={{padding:"10px",margin:"0px"}}>
          <p style={{color:"black"}}>1. 点击下载 <a  href={winDownload}>Mihomo Party(Windows 10/11)</a>, 然后安装</p>
          <p>2. 复制 URL(
            <span>{suburl}</span>
            <Clipboard
              style={{"borderRadius": "5px", "padding": "4px"}}
              onSuccess={()=>{ setClipboard(true) }}
              data-clipboard-text={suburl}>
              { clipboard ? "copied" : "copy to clipboard" }
            </Clipboard>
          ) </p>
          <p>3. 点击左侧订阅卡片后，在右侧的订阅管理面板的输入框中点击粘贴按钮并导入</p>
          <p>4. 点击系统代理卡片，开启代理上网</p>
        </Tab.Pane>)
      }
    },
    {
      desktop:true,
      menuItem:<Menu.Item key='pro3'>
        <svg id="macos" viewBox="0 0 36 24" style={{"color":"#333","width":"28px","marginRight":"8px", "verticalAlign": "middle"}} >
          <path fillRule="evenodd" clipRule="evenodd" d="M15.8794 12.7011C16.0168 10.3047 17.0395 6.40098 19.2618 2H8C6.89543 2 6 2.89543 6 4V20C6 21.1046 6.89543 22 8 22H19.3675C19.1836 20.8126 19.1204 19.6274 19.1251 18.5173C18.6765 18.5758 18.2212 18.6074 17.7647 18.6074C16.1518 18.6074 14.553 18.2135 13.2161 17.6272C11.8949 17.0477 10.7514 16.2451 10.1175 15.3648C9.88356 15.0399 9.95732 14.5868 10.2823 14.3528C10.6072 14.1189 11.0603 14.1926 11.2942 14.5176C11.7192 15.1078 12.6052 15.7759 13.7986 16.2993C14.9764 16.8159 16.3776 17.1574 17.7647 17.1574C18.2344 17.1574 18.7057 17.1182 19.1695 17.0463C19.2362 15.825 19.3653 14.7574 19.4682 13.9668H17.0882C16.4229 13.9668 15.8383 13.4198 15.8794 12.7011ZM20.578 18.2311C21.1884 18.0702 21.7723 17.8645 22.3133 17.6272C23.6346 17.0477 24.7781 16.2451 25.4119 15.3648C25.6459 15.0399 25.5721 14.5868 25.2472 14.3528C24.9222 14.1189 24.4691 14.1926 24.2352 14.5176C23.8102 15.1078 22.9243 15.7759 21.7309 16.2993C21.3857 16.4507 21.0213 16.587 20.6438 16.7041C20.7199 15.5944 20.844 14.6233 20.9397 13.8982C21.0365 13.164 20.4648 12.5168 19.7277 12.5168H17.346C17.5383 10.2196 18.5895 6.37024 20.8934 2H28C29.1046 2 30 2.89543 30 4V20C30 21.1046 29.1046 22 28 22H20.8358C20.6199 20.723 20.5588 19.4319 20.578 18.2311ZM12.5 6.275C12.9004 6.275 13.225 6.59959 13.225 7V9.35294C13.225 9.75335 12.9004 10.0779 12.5 10.0779C12.0996 10.0779 11.775 9.75335 11.775 9.35294V7C11.775 6.59959 12.0996 6.275 12.5 6.275ZM24.225 7C24.225 6.59959 23.9004 6.275 23.5 6.275C23.0996 6.275 22.775 6.59959 22.775 7V9.35294C22.775 9.75335 23.0996 10.0779 23.5 10.0779C23.9004 10.0779 24.225 9.75335 24.225 9.35294V7Z" fill="currentColor"></path>
        </svg>
        MacOS

      </Menu.Item>,
      render: () => {
        return (<Tab.Pane style={{padding:"10px",margin:"0px"}}>
          <p style={{color:"black"}}>1. 点击下载 <a  href={armDownload}>Mihomo Party Arm</a>/<a  href={x86Download}>Mihomo Party Intel</a>, 然后安装</p>
          <p>2. 复制 URL(
            <span>{suburl}</span>
            <Clipboard
              style={{"borderRadius": "5px", "padding": "4px"}}
              onSuccess={()=>{ setClipboard(true) }}
              data-clipboard-text={suburl}>
              { clipboard ? "copied" : "copy to clipboard" }
            </Clipboard>
          ) </p>
          <p>3. 点击左侧订阅卡片后，在右侧的订阅管理面板的输入框中点击粘贴按钮并导入</p>
          <p>4. 点击系统代理卡片，开启代理上网</p>
        </Tab.Pane>)
      }
    },
    {
      desktop:true,
      menuItem:<Menu.Item key='pro3'>
      <svg id="linux" viewBox="0 0 36 24" style={{"color":"#333","width":"30px","marginRight":"8px", "verticalAlign": "middle"}} >
      <path fillRule="evenodd" clipRule="evenodd" d="M6 3.5C6 2.67157 6.67157 2 7.5 2H27.5C28.3284 2 29 2.67157 29 3.5V20.5C29 21.3284 28.3284 22 27.5 22H7.5C6.67157 22 6 21.3284 6 20.5V3.5ZM8.96967 4.96967C9.26256 4.67678 9.73744 4.67678 10.0303 4.96967L13.5303 8.46967C13.8232 8.76256 13.8232 9.23744 13.5303 9.53033L10.0303 13.0303C9.73744 13.3232 9.26256 13.3232 8.96967 13.0303C8.67678 12.7374 8.67678 12.2626 8.96967 11.9697L11.9393 9L8.96967 6.03033C8.67678 5.73744 8.67678 5.26256 8.96967 4.96967ZM13 15.2C12.5582 15.2 12.2 15.5582 12.2 16C12.2 16.4418 12.5582 16.8 13 16.8H20.5C20.9418 16.8 21.3 16.4418 21.3 16C21.3 15.5582 20.9418 15.2 20.5 15.2H13Z" fill="currentColor"></path>
      </svg>
        More
      </Menu.Item>,
      render: () => {
        return (<Tab.Pane style={{padding:"10px",margin:"0px"}}>
          <p style={{color:"black"}}>1. 如果需要更多平台和版本，请前往下载 <a  href="https://github.com/mihomo-party-org/mihomo-party/releases">https://github.com/mihomo-party-org/mihomo-party/releases</a>, 然后安装</p>
          <p>2. 复制 URL(
            <span>{suburl}</span>
            <Clipboard
              style={{"borderRadius": "5px", "padding": "4px"}}
              onSuccess={()=>{ setClipboard(true) }}
              data-clipboard-text={suburl}>
              { clipboard ? "copied" : "copy to clipboard" }
            </Clipboard>
          ) </p>
          <p>3. 点击左侧订阅卡片后，在右侧的订阅管理面板的输入框中点击粘贴按钮并导入</p>
          <p>4. 点击系统代理卡片，开启代理上网</p>
        </Tab.Pane>)
      }
    }
  ]

  const [clipboard,setClipboard] = useState(false);

  useEffect(()=>{
    if(clipboard == true){
      setTimeout(()=>{
        setClipboard(false)
      },3000)
    }
  },[clipboard])

  return (
  <Fragment>

    <Header as='h2' color="blue">
      {t("settings.mihomo.title")}
      <Header.Subheader>
      {t("settings.mihomo.notes")}
      </Header.Subheader>
    </Header>
    <p>{t("settings.mihomo.steps")}</p>
    <p>1.{t("settings.mihomo.step1")}</p>
    <p>2.{t("settings.mihomo.step2")}</p>
    <p>3.{t("settings.mihomo.step3")}</p>

    <Table>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell colSpan='3'>
            {t("settings.mihomo.tab.title")}
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        <Segment>
          <Tab  menu={{ color:"blue", secondary: true}} panes={panes} />
        </Segment>
      </Table.Body>
    </Table>

  </Fragment>
  )
}
export {Guide};
